new Swiper('.logo-slider', {
    autoplay: {
      delay: 3000,
    },
    loop: true, 
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
     },
     breakpoints: {
        0: {
          slidesPerView: 1.4,
          spaceBetween: 20,
        },
         580: {
          slidesPerView: 2.4,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
     },
});